import store from 'store2'

const NAMESPACE = 'PokeQuestWiki'

const storage = store.namespace(NAMESPACE)

export default storage
